import { dateToMessageFormat } from '../date-to-message-format/dateToMessageFormat';
import { isBetween2And6Days, isBetween2And6DaysAgo, isLastNight, isMoreThan7Days, isMoreThan7DaysAgo, isThisEvening, isToday, isTomorrow, isTonight, isYesterday, } from './helpers/dateUtils';
var defaultValidators = {
    moreThan7DaysAgo: isMoreThan7DaysAgo,
    between2And6DaysAgo: isBetween2And6DaysAgo,
    yesterday: isYesterday,
    lastNight: isLastNight,
    today: isToday,
    thisEvening: isThisEvening,
    tonight: isTonight,
    tomorrow: isTomorrow,
    between2And6Days: isBetween2And6Days,
    moreThan7Days: isMoreThan7Days,
};
export var dateMapDistanceToNow = function (config) { return function (date, locale) {
    var distanceConfig = Object.entries(config);
    var resourceStringValue = null;
    for (var _i = 0, distanceConfig_1 = distanceConfig; _i < distanceConfig_1.length; _i++) {
        var distance = distanceConfig_1[_i];
        var distanceName = distance[0], options = distance[1];
        if (options.validate) {
            var isValid = options.validate(date);
            if (isValid) {
                resourceStringValue = options.value;
                break;
            }
        }
        else if (distanceName in defaultValidators) {
            var validator = defaultValidators[distanceName];
            var isValid = validator(date);
            if (isValid) {
                resourceStringValue = options.value;
                break;
            }
        }
        else {
            throw new Error("There is no default validator for '".concat(distanceName, "'. You should always add a validator function for the non-default distance names"));
        }
    }
    if (resourceStringValue === null) {
        return '';
    }
    return dateToMessageFormat(resourceStringValue)(date, locale);
}; };
//# sourceMappingURL=dateMapDistanceToNow.js.map